var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{staticClass:"confirm-password-input"},[(_vm.label)?_c('label',{staticClass:"input-label confirm-password-input-label",class:{required: _vm.required},attrs:{"for":"password"}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('a-input-password',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      'confirmPassword',
      {
        rules: [
          {
            required: this.required,
            message: _vm.$t('validation.required'),
          },
          {
            validator: _vm.compareToFirstPassword,
          } ],
      } ]),expression:"[\n      'confirmPassword',\n      {\n        rules: [\n          {\n            required: this.required,\n            message: $t('validation.required'),\n          },\n          {\n            validator: compareToFirstPassword,\n          },\n        ],\n      },\n    ]"}],attrs:{"name":"confirm-password","type":"password","placeholder":_vm.placeholder},on:{"change":_vm.handleConfirmChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }